import { Guest } from "../types";
import fetchContentType from "../utils";

export const guestsPerPage = 12;

export const getGuests = async (page: number, pageSize = guestsPerPage) => {
  return fetchContentType<{
    data: Guest[];
    meta: { pagination: { total: number } };
  }>(
    "guests",
    {
      filters: {},
      pagination: {
        page,
        pageSize,
      },
      populate: ["image"],
      sort: ["name:asc"],
    },
    false,
  );
};
